// extracted by mini-css-extract-plugin
export default {"verticalCenter":"styles_verticalCenter__QEJt7"};